import * as swcHelpers from '@swc/helpers';
import { useQuery } from '@grandvisionhq/graphql';
import { useStockIndicator } from '@grandvisionhq/inventory';
import GET_SHOPPING_LIST from '../operations/queries/get-shopping-list.js';
import { mapShoppingListToWishlistItems } from '../utils/map-shopping-list-to-wishlist-items.js';

const useGetAnonWishlist = ({ locale , isAuthLoading , isUserLoggedIn , localWishlist , clearWishlist  })=>{
    const { thresholds  } = useStockIndicator();
    const anonWishlistQueryOptions = {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        skip: isAuthLoading || isUserLoggedIn || !localWishlist,
        variables: {
            shoppinglistId: (localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id) || ''
        },
        onCompleted: (data)=>{
            var ref;
            if (((ref = data.shoppinglistById.failure) === null || ref === void 0 ? void 0 : ref.__typename) === 'ShoppinglistNotFoundFailure') {
                clearWishlist();
            }
        }
    };
    const { data: anonWishlistData , loading: isLoading , error , refetch ,  } = useQuery(GET_SHOPPING_LIST, swcHelpers.objectSpread({}, anonWishlistQueryOptions));
    var ref1;
    const mappedAnonData = anonWishlistData ? {
        items: mapShoppingListToWishlistItems(locale, anonWishlistData.shoppinglistById.shoppinglist, thresholds),
        id: (ref1 = localWishlist === null || localWishlist === void 0 ? void 0 : localWishlist.id) !== null && ref1 !== void 0 ? ref1 : ''
    } : null;
    return {
        data: !error ? mappedAnonData : null,
        loading: isLoading,
        error,
        refetch: swcHelpers.asyncToGenerator(function*() {
            yield refetch();
        })
    };
};

export { useGetAnonWishlist };
//# sourceMappingURL=use-get-anon-wishlist.js.map
